import React, { Children, Component } from 'react';
import PropTypes from 'prop-types';
import Tabs from '../Tabs';
import withReduxForm from './hoc/withReduxForm';


class BaseForm extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.func])).isRequired,
    reset: PropTypes.func.isRequired,
    active: PropTypes.number.isRequired,
    controls: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    valid: PropTypes.bool.isRequired,
    onTabChange: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    onTabChange: () => null,
  };

  onTabChange = index => () => {
    this.props.onTabChange(index, this.props.pristine, this.props.reset, this.props.handleSubmit);
  }

  renderSection = (item) => {
    if (!item) return null;

    return (
      <Tabs.Tab title={item.props.title} {...item.props} onTabClick={this.onTabChange}>
        <div className="u-min-height-576">
          {item.props.children}
        </div>
      </Tabs.Tab>
    );
  }

  renderSections() {
    return Children.map(this.props.children, this.renderSection);
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <fieldset disabled={this.props.submitting}>
          <div className={this.props.className}>
            <Tabs active={this.props.active} TabBarAction={this.props.TabBarAction}>
              {this.renderSections()}
            </Tabs>
            {this.props.controls(this.props.pristine, this.props.submitting, this.props.valid)}
          </div>
        </fieldset>
      </form>
    );
  }
}

export const Tab = ({ title, deny, allow, disabled, ...props }) => <div {...props} />;
Tab.propTypes = {
  title: PropTypes.string.isRequired,
  deny: PropTypes.number,
  allow: PropTypes.number,
  disabled: PropTypes.bool,
};
Tab.defaultProps = {
  deny: null,
  allow: null,
  disabled: false,
};

const BaseFormContainer = withReduxForm(BaseForm);
BaseFormContainer.Tab = Tab;

export default BaseFormContainer;
